<template>
  <VJsoneditor
    v-model="objectJSON"
    @input="update"
    height="600px"
    :options="options"
    :plus="false"
  />
</template>

<script>
import VJsoneditor from 'v-jsoneditor'
import debounce from 'lodash.debounce'
export default {
  model: {
    prop: 'data',
    event: 'update'
  },
  props: ['data', 'type'],
  components: {
    VJsoneditor
  },
  data () {
    return {
      objectJSON: {},
      options: {
        mode: 'code'
      }
    }
  },
  methods: {
    update: debounce(function () {
      this.$emit('update', { ...this.data, ...this.objectJSON })
    }, 400)
  },
  beforeMount () {
    // console.log(this.data)
    this.objectJSON.output = this.data.output
    this.objectJSON.context = this.data.context
    this.objectJSON.actions = this.data.actions
    // console.log(this.objectJSON)
  }
}
</script>

<style>
.jsoneditor {
  border: thin solid rgba(67, 160, 72, 0);
}
.jsoneditor-menu {
  background-color: rgb(67, 160, 71);
  border-bottom: 1px solid rgb(67, 160, 71);
}
.jsoneditor-menu a.jsoneditor-poweredBy {
  display: none;
}
</style>
